import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const cutSurfaceNodesMutation = gql`
  mutation cutSurfaceNodes($input: [CutSurfaceNodesInput!]!) {
    cutSurfaceNodes(input: $input) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(cutSurfaceNodesMutation);
